/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit ExternalMappingsCount/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import Tysiav2UserCouple from 'DesignSystem/Svgs/Tysiav2UserCouple/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function ExternalMappingsCount({
  children,
  viewPath = "/App/Account/Content/Settings/Content/ConnectApps/App/Content/Connections/Content/Connection/Content/ExternalMappingsCount"
  
}) {
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let externalMappingsAggregateCountValueData = fromData.useDataFormat({ viewPath,
context: 'external_mappings',
path: 'aggregate.count',
format: fromHelpers.getCount,
})
let dtTypographyFontsizeM = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'typography.fontSize.m'
        })
let dtColorsNeutral500 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.500'
        })
  return (<React.Fragment
>
<div
  data-testid="ExternalMappingsCount.Horizontal"
  data-view-path={viewPath}
 style={{'--g-1-pSr1o': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs}}
 className={`views-block ${styles.Horizontal}`}
>
<Tysiav2UserCouple
  viewPath={`${viewPath}/Tysiav2UserCouple`}
 marginTop={dtSpaceXxs}
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 fontSize={dtTypographyFontsizeM}
 color={dtColorsNeutral500}
 data="external_mappings.aggregate.count"
 format="helpers.js getCount"
 text={externalMappingsAggregateCountValueData}
/>
</div>
{children}
</React.Fragment>)
}